import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchNotificationsStart,
    fetchNotificationsSuccess,
    fetchNotificationsFail,
    markNotificationReadStart,
    markNotificationReadSuccess,
    markNotificationReadFail,
    deleteNotificationStart,
    deleteNotificationSuccess,
    deleteNotificationFail,
} from '../slices/notificationsSlice';
import { getRequest, putRequest, deleteRequest } from '../../network';
import { getNotifications, markNotificationAsRead, deleteNotification } from '../apis';

// Generic handler for Notification API calls
function* notificationSaga(action) {
    const { endpoint, method = 'get', successAction, failAction, payload = null } = action.payload;
    const requestFunction = method === 'put' ? putRequest : method === 'delete' ? deleteRequest : getRequest;

    try {
        const response = yield call(requestFunction, endpoint, payload);
        yield put(successAction(response));
    } catch (error) {
        yield put(failAction(error.message));
    }
}

// Individual sagas
function* fetchNotificationsSaga() {
    yield notificationSaga({
        payload: {
            endpoint: getNotifications,
            successAction: fetchNotificationsSuccess,
            failAction: fetchNotificationsFail,
        },
    });
}

function* markNotificationReadSaga(action) {
    yield notificationSaga({
        payload: {
            endpoint: markNotificationAsRead.replace(':id', action.payload.id),
            method: 'put',
            successAction: markNotificationReadSuccess,
            failAction: markNotificationReadFail,
        },
    });
}

function* deleteNotificationSaga(action) {
    yield notificationSaga({
        payload: {
            endpoint: deleteNotification.replace(':id', action.payload.id),
            method: 'delete',
            successAction: deleteNotificationSuccess,
            failAction: deleteNotificationFail,
        },
    });
}

// Watcher saga
export function* watchNotifications() {
    yield takeEvery(fetchNotificationsStart.type, fetchNotificationsSaga);
    yield takeEvery(markNotificationReadStart.type, markNotificationReadSaga);
    yield takeEvery(deleteNotificationStart.type, deleteNotificationSaga);
}